<ng-container *ngIf="!loading">
  <div class="header-content">
    <se-fe-alert *ngIf="emailNotAllowed" seFeDataType="error">
      {{ 'SE_PO_SE_PERSONA_PICKER_FEATURE_HOUSEHOLD_INVITE.ERROR' | translate }}
    </se-fe-alert>
    <se-fe-icon seFeDataName="spot_household" seFeDataSize="950" [seFeDataMargin]="false"></se-fe-icon>
    <se-po-highlight-label class="list-spacing" theme="child" [label]="'SE_PO_SE_PERSONA_PICKER_FEATURE_HOUSEHOLD_INVITE.TITLE' | translate"></se-po-highlight-label>
    <div class="description">{{ 'SE_PO_SE_PERSONA_PICKER_FEATURE_HOUSEHOLD_INVITE.DESCRIPTION' | translate: {childName: fullName} }}</div>
  </div>
  <se-po-add-guardian #inviteControls>
  </se-po-add-guardian>
  <se-fe-button seFeDataEmphasis="high" [seFeDataFullWidth]="true" [seFeDataIsLoading]="submitting" (click)="sendInvite()">{{ 'SE_PO_SE_PERSONA_PICKER_FEATURE_HOUSEHOLD_INVITE.SEND' | translate }}</se-fe-button>
  <se-fe-button seFeDataEmphasis="low" [seFeDataFullWidth]="true" (click)="skipInvite()" style="margin-top: 8px;">{{ 'SE_PO_SE_PERSONA_PICKER_FEATURE_HOUSEHOLD_INVITE.SKIP' | translate }}</se-fe-button>
</ng-container>
